
import { useTranslate } from "../language"
import "./Status.scss"


export default (props: {type?: string, label: string, onClick?: () => void}) => {

    const {t} = useTranslate()

    if(props.type === "IN_PROGRESS"){
        return <StatusInProgress label={t(props.label)} />
    }else if (props.type === "COMPLETED"){
        return <StatusCompleted label={t(props.label)} />
    }else if(props.type === "WAITING_PAYMENT"){
        return <StatusInProgress label={t("Ready for Preview")} onClick={props.onClick} />
    }else{
        return <StatusPlain label={t(props.label)} />
    }

}

const StatusInProgress = (props: {label: string, onClick?: () => void}) => {

    const {t} = useTranslate()

    return <div className="status in-progress" onClick={props.onClick}>
        <div className="label">{t(props.label)}</div>
    </div>
}

const StatusCompleted = (props: {label: string}) => {

    const {t} = useTranslate()
    
    return <div className="status completed">
        <div className="label">{t(props.label)}</div>
    </div>
}

const StatusPlain = (props: {label: string}) => {

    const {t} = useTranslate()
    
    return <div className="status plain">
        <div className="label">{t(props.label)}</div>
    </div>
}